import { css } from '@emotion/react'
import {
  WizardHeadingWithSideContent,
  WizardHeadingWithSideContentProps,
} from 'components/wizard/wizardHeadingWithSideContent/WizardHeadingWithSideContent'
import immer from 'immer'
import { ReactElement } from 'react'

type WizardHeadingWithImageProps = Omit<WizardHeadingWithSideContentProps, 'side'> & {
  image?: ReactElement
}

export function WizardHeadingWithImage(props: WizardHeadingWithImageProps) {
  return (
    <WizardHeadingWithSideContent
      {...immer(props, (props) => {
        delete props.image
      })}
      side={props.image}
      sideColumnCss={css`
        & img {
          max-width: 100%;
          max-height: 13rem;
          object-fit: contain;
        }
      `}
    />
  )
}
